<i18n
  src="@/locales/views/packing_house/production/final_packing_list_simplified/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_processes')"
  >
  </go-back-link>

  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}<span class="space-icon"></span
      ><i class="fa-solid fa-chevron-right fa-xs"></i
      ><span class="space-icon"></span>{{ packing_house_process?.name }}
    </h1>
  </div>

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :containers="containers"
      :packages_from_stock="packages_from_stock"
      :current-page="current_page"
      :stats="stats"
    >
    </router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/final_packing_list_simplified/show_process.js";

export default {
  name: "PHProductionFinalPackingListSimplifiedShowProcess",
  props: {
    packing_house_process_id: {
      required: true,
    },
    packing_house_id: {
      required: true,
    },
  },
  data() {
    return {
      load_data_general: false,
      load_containers: false,
      load_packages_from_stock: false,
      packing_house_process: null,
      containers: [],
      stats: {
        containers: { total: null },
        packages_from_stock: { total: null },
      },
      packages_from_stock: [],
      rows_per_page: 12,
      current_page: { containers: 1, packages_from_stock: 1 },
    };
  },
  methods: {
    loadData: async function () {
      if (
        this.option_tabs[0].route.name === this.$route.name &&
        !this.load_containers
      ) {
        await this.fetchContainers();
      } else if (
        this.option_tabs[1].route.name === this.$route.name &&
        !this.load_packages_from_stock
      ) {
        await this.fetchPackagesFromStock();
      }
      this.load_data_general = true;
    },
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers({
        packing_house_process_id: this.packing_house_process_id,
        current_page: this.current_page.containers,
        rows_per_page: this.rows_per_page,
      });
      this.containers = response.data.containers;
      this.stats.containers = response.data.stats;
      this.load_containers = true;
    },
    fetchPackagesFromStock: async function () {
      const response = await Requester.fetchPackagesFromStock({
        packing_house_process_id: this.packing_house_process_id,
        current_page: this.current_page.packages_from_stock,
        rows_per_page: this.rows_per_page,
      });
      this.packages_from_stock = response.data.packages;
      this.stats.packages_from_stock = response.data.stats;
      this.load_packages_from_stock = true;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-container-storage",
          route: { name: this.routeName("show_process_containers") },
        },
        {
          name: this.$t("labels.packages_from_stock_title"),
          icon: "fa-solid fa-boxes",
          route: { name: this.routeName("show_process_packages_from_stock") },
        },
      ];
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fillOptions();
        this.fetchPackingHouseProcess();
        this.loadData();
      })
    );
  },
  watch: {
    $route: function () {
      this.loadData();
    },
    "current_page.packages_from_stock": function () {
      this.fetchPackagesFromStock();
    },
    "current_page.containers": function () {
      this.fetchContainers();
    },
  },
};
</script>
